import React from 'react';
import {
  ComponentParams,
  ComponentRendering,
  useSitecoreContext,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { RenderingProps } from './shared.types';

interface Props {
  rendering?: (ComponentRendering & { params?: ComponentParams }) | RenderingProps['rendering'];
  fieldName?: string;
}

export const PromptForNoArticleResults = (props?: Props): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  if (isEditing) {
    return (
      <h3>
        &quot;{props?.fieldName}&quot; field is empty or No Articles Result for{' '}
        {props?.rendering?.componentName}.
      </h3>
    );
  }

  return <></>;
};
